import { Pipe, PipeTransform } from '@angular/core';
import { getConstant } from '../constants';

/**
 * @usage {{value | constant : 'domain.prefix' : 'default ' + value }} OR {{'domain.prefix.' + value | constant}}
 */
@Pipe({
  name: 'constant',
})
export class ConstantPipe implements PipeTransform {
  transform(value: any, prefix?: string, defaultValue = ''): any {
    return getConstant(prefix ? `${prefix}.${value}` : value, defaultValue);
  }
}
